<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-btn class="ml-auto" icon to="/message">
        <v-icon>flaticon-speech-bubble</v-icon>
      </v-btn>
      <v-btn v-if="showDelivery == true" icon to="/delivery">
        <v-icon>flaticon-food</v-icon>
      </v-btn>
      <v-btn icon to="/invoice">
        <v-icon>flaticon-clock-1</v-icon>
      </v-btn>
    </v-app-bar>

    <v-carousel
      cycle
      height="auto"
      show-arrows-on-hover
      v-if="sliders.length > 0"
      hide-delimiters
    >
      <v-carousel-item
        v-for="item in sliders"
        :key="item.id_slider"
        :src="item.ruta_imagen_app"
      ></v-carousel-item>
    </v-carousel>

    <v-row class="summary justify-center" v-if="profile[0] && profile[1]">
      <v-col class="pa-4 text-left">
        <div>
          {{ language.code }} :
          <span class="font-weight-black">{{ profile[0].codigo }}</span>
        </div>

        <div>{{ language.address }} :</div>
        <span class="font-weight-black">{{ profile[1].DIRECCION_FULL }}</span>
      </v-col>
    </v-row>

    <h2 class="general-title-app mt-5 mb-2">{{ language.my_packages }}</h2>

    <div class="new-list-of-packages" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <template class="item-conteiner">
            <div class="pb-2">
              <v-list-item :key="index">
                <v-list-item-content>
                  <div class="new-list-of-packages__item-content">
                    <img
                      style="width:60px;height:6                           0px;"
                      src="@/assets/box-item.png"
                      :alt="item.contenido"
                    />
                    <div class="new-list-of-packages__genearl-info">
                      <div class="detail__text" style="color:#929DB1;">
                        {{ item.fec_creacion }}
                      </div>
                      <div
                        class="detail__text "
                        style="color:#F7AA35;font-size: 16px !important;"
                      >
                        <b>Estatus :</b>{{ item.desc_estatus_proceso }}
                      </div>
                      <div class="detail__text">
                        <b>Contenido </b> {{ item.contenido }}
                      </div>
                      <div class="detail__text">
                        <b>{{ language.pack_no }}</b> : {{ item.guia }}
                      </div>
                      <div class="detail__text">
                        <b>{{ language.tracking_no }}:</b>
                        {{ item.tracking_number }}
                      </div>
                      <div class="detail__text">
                        <b>{{ language.weight }} :</b>
                        {{
                          item.peso +
                            " " +
                            (item.peso > 1
                              ? " " + language.pounds
                              : " " + language.pound)
                        }}
                      </div>
                    </div>
                    <div>
                      <v-btn
                        class="dots-btn"
                        :loading="loading"
                        :disabled="loading"
                        @click="detailsContentAction(item.detalle)"
                      >
                        <span></span>
                        <span></span>
                        <span></span>
                      </v-btn>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <div
                class="btn-status text-left px-2"
                v-if="item.mostrar_boton == 0"
              >
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  small
                  block
                  color="secondary"
                  class
                  @click="pickFile(item.guia, item.id_)"
                >
                  {{ language.upload_invoice }}

                  <!-- <v-icon right dark>cloud_upload</v-icon> -->
                </v-btn>
              </div>
            </div>
          </template>
        </template>
      </v-list>
    </div>

    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{ language.you_have_no_packages_available }}
        </div>
      </div>
      <v-progress-circular
        :size="90"
        color="blue"
        indeterminate
        class="loading-center"
        v-else
      ></v-progress-circular>
    </div>

    <input
      type="file"
      style="display: none"
      ref="image"
      accept="image/*"
      @change="onFilePicked"
    />

    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ language.ship_via }}
        </v-card-title>

        <v-card-text>
          <v-radio-group v-model="ShipmentType">
            <v-radio label="Air" :value="1"></v-radio>
            <v-radio label="Ocean" :value="2"></v-radio>
            <v-radio label="Consolidate" :value="10"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            {{ language.cancel }}
          </v-btn>
          <v-btn color="green darken-1" text @click="shipVia">
            {{ language.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_details" width="500">
      <template> </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ language.details }}
        </v-card-title>

        <v-card-text>
          <v-simple-table v-if="detailsContent != null">
            <template v-slot:default>
              <tbody>
                <tr v-for="item in detailsContent" :key="item[0]">
                  <td>{{ item[0] }}</td>
                  <td>
                    <b>{{ item[1] }}</b>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detailsContentClose">
            {{ language.close }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="mainDrawerNav" v-if="drawer" absolute bottom temporary>
      <div>
        <v-btn icon @click.stop="drawer = !drawer">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <div class="mainDrawerNav__user" to="/profile">
        <img src="@/assets/user_login.png" alt="logo" />

        <div class="user__content" v-if="profile.length > 0">
          <h2 class="user__name" v-if="profile[0].nombre != ''">
            Hola, {{ profile[0].nombre }}
          </h2>
          <p class="user__local" v-if="profile[0].descripcion_oficina != ''">
            {{ profile[0].descripcion_oficina }}
          </p>
        </div>
      </div>
      <div class="mb-2 mt-2">
        <v-btn
          :loading="loading"
          :disabled="loading"
          large
          block
          color="secondary"
          class
          @click="logOut"
        >
          Cerrar Sección
        </v-btn>
      </div>

      <v-list nav dense>
        <v-list-item-group v-model="group">
          <v-list-item to="/home">
            <v-list-item-title><img src="" alt="" />Paquetes</v-list-item-title>
          </v-list-item>

          <v-list-item to="/prealert">
            <v-list-item-title
              ><img src="" alt="" />Pre-alerta</v-list-item-title
            >
          </v-list-item>

          <v-list-item to="/office">
            <v-list-item-title
              ><img src="" alt="" />Sucursales</v-list-item-title
            >
          </v-list-item>

          <v-list-item to="/help">
            <v-list-item-title><img src="" alt="" />Ayuda</v-list-item-title>
          </v-list-item>

          <v-list-item to="/profile">
            <v-list-item-title><img src="" alt="" />Perfil</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
// import { mapState } from "vuex";
var files = [];
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
            this.getStatus();
          }
        }
      }
    );
    this.$store.watch(
      (state, getters) => getters.profile,
      // (newValue, oldValue) => {
      () => {
        this.showDeliveryFc();
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
      this.getStatus();
      this.getSlider();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
      this.getStatus();
      this.getSlider();
    }

    this.showDeliveryFc();
  },
  data() {
    return {
      clipped: false,
      items: [],
      status: [],
      sliders: [],
      currentUser: undefined,
      noData: false,
      loading: false,
      imageFile: null,
      imageName: "",
      guia: null,
      idpack: null,
      showDelivery: false,
      dialog: false,
      ShipmentType: null,
      ShipmentTypePackId: null,
      ShipmentTypePackIdparent: null,
      shipVialoading: false,
      loadmorerequest: false,
      loading_refresh: false,
      dialog_details: false,
      detailsContent: null,
      drawer: false,
      group: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    profile: function() {
      return this.$store.getters.profile;
    },
    language: function() {
      return this.$store.getters.language;
    },
  },
  methods: {
    detailsContentAction(details) {
      this.dialog_details = true;
      var rows = details.split(";");
      var content = [];
      rows.map((item) => {
        content.push(item.split(","));
      });
      this.detailsContent = content;
    },
    detailsContentClose() {
      this.dialog_details = false;
      this.detailsContent = null;
    },
    logOut() {
      this.$store.dispatch("logout");
      window.MobileApi.signOut();

      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.logout, formData).then(
        // response => {},
        () => {},
        () => {}
      );
    },

    changeShipmentType(
      currentShipmentType,
      currentPackId,
      ShipmentTypePackIdparent
    ) {
      this.ShipmentType = currentShipmentType;
      this.ShipmentTypePackId = currentPackId;
      this.ShipmentTypePackIdparent = ShipmentTypePackIdparent;
      this.dialog = true;
    },
    shipVia() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      formData.append("text10", this.ShipmentTypePackId);
      formData.append("text11", this.ShipmentTypePackIdparent);
      formData.append("text13", this.ShipmentType);
      // console.log(this.currentUser);
      this.shipVialoading = true;
      this.dialog = false;
      this.$http.post(Server.shipVia, formData).then(
        (response) => {
          // console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.getPacks();
          } else {
            // this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );
    },

    showDeliveryFc() {
      if (this.profile.length > 0) {
        if (
          this.profile[0].domicilio != "" &&
          this.profile[0].domicilio != 0 &&
          this.profile[0].domicilio != "0" &&
          this.profile[0].domicilio != undefined
        ) {
          this.showDelivery = true;
        } else {
          this.showDelivery = false;
        }
      } else {
        this.showDelivery = false;
      }
    },
    pickFile(guia, idpack) {
      window.MobileApi.uploadInvoice(
        Server.uploadInvoice,
        guia,
        idpack,
        this.currentUser.userName,
        this.getPacks
      );
    },
    onFilePicked() {
      this.loading = true;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          var formData = new FormData();
          formData.append("text1", this.currentUser.userName);
          formData.append("text3", this.currentUser.pushId);
          formData.append("device", window.MobileApi.device);
          formData.append("PARAMETRO2", this.guia);
          formData.append("PARAMETRO1", this.idpack);
          formData.append("photo", this.imageFile);
          this.$http.post(Server.uploadInvoice, formData).then(
            // response => {
            () => {
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        });
      }
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      // console.log(this.currentUser);
      var _store = this.$store;
      if (this.loadmorerequest === true) {
        this.loading_refresh = true;
      }
      this.$http.post(Server.packs, formData).then(
        (response) => {
          // console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.items = response.body;
            this.loadmorerequest = false;
            this.loading_refresh = false;
            this.shipVialoading = false;
            _store.dispatch("setStatus", response.body);
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );
    },
    getStatus() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      console.log(this.currentUser);
      var _store = this.$store;
      this.$http.post(Server.status, formData).then(
        (response) => {
          console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.status = response.body;

            _store.dispatch("setStatus", response.body);
          } else {
            // this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
    loadMore() {
      this.loadmorerequest = true;
      this.getPacks();
    },
    getSlider() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      // console.log(this.currentUser);
      var _store = this.$store;
      this.$http.post(Server.slider, formData).then(
        (response) => {
          // console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.sliders = response.body;

            _store.dispatch("setStatus", response.body);
          } else {
            // this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
